import { Component, OnInit } from '@angular/core';
import { BaseTabsUpdateComponent, TabsContainerService, BaseDataService, UserService } from 'yt-ng-framework';
import { Company } from './company';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-company-tab-update',
  templateUrl: './company-tab-update.component.html'
})
export class CompanyTabUpdateComponent extends BaseTabsUpdateComponent<Company> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected tabsContainerService: TabsContainerService<Company>,
    protected baseDataService: BaseDataService,
    protected userService: UserService
  ) {
    super(activatedRoute, tabsContainerService, baseDataService, userService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.defaultUpdateButtons.ButtonsConfig.SaveButtonConfig.Visible = false;
    this.defaultUpdateButtons.ButtonsConfig.ResetButtonConfig.Visible = false;
  }

}
